module.exports = "/images/protected-4-year-seller.png?988f145c82a0972f98e79bb81b736b55";